module.exports = __webpack_public_path__ + "assets/img/contentBj3.ff6e8caa.png";